module.exports = __webpack_public_path__ + "@/assets/img/19.30e083fa.jpg";